import { createContext, use } from 'react';

/** Where "Exit" leads once the game is over (U-OVER-02): the logbook, or home for a guest. */
export const GameExit = createContext('/logbook');

export const useGameExit = (): string => use(GameExit);
